import React from 'react';
import TableItem from './FloorPlan/TableItem';

export default function FloorLayoutRenderer({ tables, onTableClick, isInteractive = false, isDraggable = true }) {
  return (
    <div
      className="floor-area"
      style={{
        position: 'relative',
        width: (isDraggable ? '1000px' : '90vw'),
        height: '600px',
        background: '#fff',
        border: '2px dashed #ccc',
        overflow: 'hidden',
        margin: '0 auto',
      }}
    >
      {tables.map((table) => (
        <TableItem
          key={table._id}
          table={table}
          allTables={tables}
          draggable={isDraggable}
          isInteractive={isInteractive}
          onClickTable={onTableClick}
        />
      ))}
    </div>
  );
}
